<div
  (scrolled)="onScroll()"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="10"
  [scrollWindow]="false"
  class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
  infiniteScroll
>
  <table
    (matSortChange)="sortData($event)"
    [class.hidden]="loading && isFirstPage"
    [dataSource]="dataSource"
    mat-table
    matSort
  >
    <!--      NAME-->
    <ng-container
      [sticky]="true"
      matColumnDef="name"
    >
      <th
        *matHeaderCellDef
        id="sort_name"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell">
          Name
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] md:w-[20rem] md:min-w-[20rem]"
          mat-cell>
        <div class="td-cell">
          <span
            (click)="(
                        eachRow?.status?.key !== 1 &&
                      (
                        this.selectedUserRole ? eachRow?.role?.key >
                        selectedUserRole && selectUser(eachRow) : eachRow?.role?.key > userRole && selectUser(eachRow)
                       )
                    )"
            [class.clickable]="eachRow?.status?.key !== 1 && (
                                selectedUserRole ?
                                (eachRow?.role?.key > selectedUserRole) :
                                eachRow?.role?.key > userRole
                             )"
          >
            {{ eachRow.firstName }} {{ eachRow.lastName }}
          </span>
        </div>
      </td>
    </ng-container>
    <!--      PRONOUN-->
    <ng-container
      matColumnDef="preferredPronouns"
    >
      <th
        *matHeaderCellDef
        id="sort_preferredPronouns"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell">
          Preference
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <div
          class="td-cell"
        >
          {{ eachRow.preferredPronouns?.value }}
        </div>
      </td>
    </ng-container>
    <!--      ROLE-->
    <ng-container
      matColumnDef="role"
    >
      <th
        *matHeaderCellDef
        id="sort_role"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell pl-[12px]">
          Role
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.role.value }}
        </div>
      </td>
    </ng-container>
    <!--      STATUS-->
    <ng-container
      matColumnDef="status">
      <th
        *matHeaderCellDef
        id="sort_status"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell">
          Status
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <div class="flex flex-row gap-[1rem] td-cell items-center">
          <div
            [ngStyle]="{'background-color': userStatusColors[eachRow?.status?.key]}"
            class="indicator"
          >
          </div>
          <div class="status-text text">
            {{ eachRow?.status?.value }}
          </div>
        </div>
      </td>
    </ng-container>
    <!--      EMAIL-->
    <ng-container
      matColumnDef="email">
      <th
        *matHeaderCellDef
        id="sort_email"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell pl-[12px]">
          Email
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        <div
          class="flex flex-row gap-[1rem] td-cell justify-center items-center">
          {{ eachRow?.emailId }}
        </div>
      </td>
    </ng-container>
    <!--      GENDER-->
    <ng-container
      matColumnDef="gender"
    >
      <th
        *matHeaderCellDef
        id="sort_gender"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell pl-[12px]">
          Gender
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <div class="td-cell">
          {{ eachRow?.gender?.value }}
        </div>
      </td>
    </ng-container>
    <!--      Date Added-->
    <ng-container
      matColumnDef="createdAt"
    >
      <th
        *matHeaderCellDef
        id="sort_createdAt"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell pl-[12px]">
          Date Added
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <div class="td-cell">
          {{ eachRow.createdAt | date:'MM/dd/YYYY' }}
        </div>
      </td>
    </ng-container>
    <!--      Clinic-->
    <ng-container
      matColumnDef="client"
    >
      <th
        *matHeaderCellDef
        id="sort_client"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell">
          Organization
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem] clickable"
          mat-cell>
        <div (click)="openClinicDashboard(eachRow)"
             class="td-cell">
          {{ eachRow?.clientName }}
        </div>
      </td>
    </ng-container>
    <!--      GROUP-->
    <ng-container
      matColumnDef="group"
    >
      <th
        *matHeaderCellDef
        class="w-[15rem] min-w-[15rem]"
        id="sort_group"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell w-[15rem] min-w-[15rem]">
          Group
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="max-w-[15rem] min-w-[15rem]"
          mat-cell>
        <ng-container *ngIf="eachRow?.role?.key == roles.participant">
          <div *ngIf="!eachRow.isAssignedToGroup">
            <strong>Unassigned</strong>
          </div>
          <div
            (click)="openGroupDetails(eachRow)"
            *ngIf="eachRow.isAssignedToGroup"
            class="td-cell"
            [class.clickable]="eachRow?.groupInfo?.isGroupAccessible">
            {{ eachRow?.groupInfo?.name }}
          </div>
        </ng-container>
      </td>
    </ng-container>
    <!--      GROUP STATUS-->
    <ng-container
      matColumnDef="groupStatus"
    >
      <th
        *matHeaderCellDef
        class="w-[15rem] min-w-[15rem]"
        id="sort_group_status"
        mat-header-cell
        mat-sort-header
      >
        <div class="th-cell">
          Group Status
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="max-w-[15rem] min-w-[15rem]"
          mat-cell>
        <div
          *ngIf="eachRow.isAssignedToGroup"
          class="flex flex-row gap-[0.5rem] td-cell items-center">
          <div
            [ngStyle]="{'background-color':
            groupStatusColors[eachRow?.groupInfo?.status?.key]}"
            class="indicator"
          >
          </div>
          <div class="status-text text">
            {{ eachRow?.groupInfo?.status?.value }}
          </div>
        </div>
      </td>
    </ng-container>
    <!--    ACTION MENU-->
    <ng-container matColumnDef="actionMenu">
      <th
        *matHeaderCellDef
        mat-header-cell
      >

      </th>
      <td *matCellDef="let eachRow"
          class="w-[2rem]"
          mat-cell>
        <button
          [matMenuTriggerFor]="menu"
          mat-icon-button
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <ng-container
            *ngIf="eachRow.role.key === roles.participant"
          >
            <button
              (click)="ChangeParticipantsGroup(eachRow)"
              mat-menu-item
            >
              <mat-icon>edit</mat-icon>
              <span class="display-name">Assign Group</span>
            </button>
          </ng-container>
          <ng-container>
            <button
              (click)="changeUserStatus(eachRow)"
              [disabled]="(userRole !== roles.superAdmin &&
              eachRow.role.key ===
              userRole) ||
              (eachRow?.status?.key === userStatusMap['inProcess'])"
              mat-menu-item
            >
              <mat-icon>edit</mat-icon>
              <span class="display-name">Change Status</span>
            </button>
          </ng-container>
          <ng-container>
            <button
              (click)="eachRow.isDeletable ? deleteUser(eachRow):{}"
              [disabled]="!eachRow.isDeletable"
              mat-menu-item
            >
              <mat-icon>delete</mat-icon>
              <span class="display-name">Delete</span>
            </button>
          </ng-container>
          <ng-container>
            <button
              (click)="resendInvite(eachRow)"
              *ngIf="eachRow.status?.key === 1 &&
              (eachRow?.useSystemMailClient || eachRow?.role?.key ===
              roles.superAdmin)"
              mat-menu-item
            >
              <mat-icon>mail</mat-icon>
              <span class="display-name">Resend Invite</span>
            </button>
          </ng-container>
          <ng-container>
            <button
              (click)="previewInvite(eachRow)"
              *ngIf="eachRow.status?.key === 1 &&
              (eachRow?.useSystemMailClient === false)"
              mat-menu-item
            >
              <mat-icon>mail</mat-icon>
              <span class="display-name">Preview Invite</span>
            </button>
          </ng-container>
        </mat-menu>
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div
    *ngIf="!loading && !dataSource.data?.length"
    class="no-data flex flex-col justify-center items-center"
  >
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
